<template>
  <span
    class="spinner"
    :class="size"
    :style="styles"
  />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'SMSpinner',
  props: {
    size: {
      type: String as () => 'small' | 'medium' | 'large',
      default: 'medium'
    },
    color: {
      type: String,
      default: 'rgba(0,0,0,0.24)'
    }
  },
  setup(props) {
    const styles = computed(() => ({ borderTopColor: props.color }))
    return { styles }
  }
})
</script>

<style lang="scss" scoped>
span.spinner{
  animation: material-spinner 4s infinite;
  &.small{
    min-height: 20px;
    width: 20px;
    border-radius: 40px;
    border: 2px transparent solid;
    border-top: 2px rgba(0,0,0,0.24) solid;
  }

  &.medium{
    min-height: 40px;
    width: 40px;
    border-radius: 80px;
    border: 5px transparent solid;
    border-top: 5px rgba(0,0,0,0.24) solid;
  }

  &.large{
    min-height: 60px;
    width: 60px;
    border-radius: 120px;
    border: 7px transparent solid;
    border-top: 7px rgba(0,0,0,0.24) solid;
  }
}
@keyframes material-spinner {
  0% {
      transform: rotate(0deg);
  }
  25% {
      transform: rotate(360deg);
  }
  50% {
      transform: rotate(720deg);
  }
  75% {
      transform: rotate(1080deg);
  }
  100% {
      transform: rotate(1440deg);
  }
}
</style>
